import React from 'react';
import Error404 from './Error404';
import { useConsole } from '../common/console/Console';
import { useAppDispatch } from '../../services/redux/hooks';
import { connect } from 'react-redux';
import { createLogPayload } from '../common/console/utilsConsole';
import { Dispatch } from '@reduxjs/toolkit';
import { addLog } from '../../services/redux/consoleSlice';

interface OwnProps extends React.PropsWithChildren<{}> {}

interface ReduxProps {
    dispatch: Dispatch;
}

type Props = OwnProps & ReduxProps;
const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    dispatch
});
interface State {
  hasError: boolean;
} 

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
}


  static getDerivedStateFromError(_error: any) {
    // Update state so the next render will show the fallback UI.
    console.error('Catastrophic error unhandled',_error)
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    try {
      const payload = createLogPayload(error, errorInfo);
      this.props.dispatch(addLog(payload));
  } catch (oErr) {
      console.error('Cant dispatch for componentDidCatch', oErr);
  }

  }
  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <header className="top-header">
          <Error404 />
        </header>
      );
    } else {
      return this.props.children;
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary);

// export default connect()(ErrorBoundary);